module.exports = __webpack_public_path__ + "static/media/arrow_left.649f2a75.svg";